export default "__VITE_ASSET__DI9dhC$M__"